module.exports = __webpack_public_path__ + "ki.svg?6e36c68267a6c21961e520ccadd3f21c";